import { createContext, useContext } from 'react';

import { mobxStore } from '@/store';

export const MobxContext = createContext(mobxStore);

export const useMobx = () => {
  return useContext(MobxContext);
};
